import I18n from 'I18n';
import { StatusTag } from 'foundations-components/transitional/components/StatusTag';
import { Text } from 'foundations-components/components/Text';
import { PUBLISH_STATUS } from 'personalization-lib/constants/assetData';
import { jsx as _jsx } from "react/jsx-runtime";
const statusTagMap = {
  [PUBLISH_STATUS.PUBLISHED]: {
    tagUse: 'published',
    getMessage: () => I18n.text('personalizationLib.publishStatus.published')
  },
  [PUBLISH_STATUS.SCHEDULED]: {
    tagUse: 'scheduled',
    getMessage: () => I18n.text('personalizationLib.publishStatus.scheduled')
  },
  [PUBLISH_STATUS.DRAFT]: {
    tagUse: 'draft',
    getMessage: () => I18n.text('personalizationLib.publishStatus.draft')
  },
  [PUBLISH_STATUS.AI_SUGGESTED]: {
    tagUse: 'inReview',
    getMessage: () => I18n.text('personalizationLib.publishStatus.aiSuggested')
  }
};
const PublishStatus = ({
  status
}) => {
  if (!status || !(status in statusTagMap)) {
    return /*#__PURE__*/_jsx(Text, {
      use: "error",
      as: "span",
      "data-test-id": "publish-status-error",
      children: I18n.text('personalizationLib.variantInfo.error')
    });
  }
  const {
    tagUse,
    getMessage
  } = statusTagMap[status];
  return /*#__PURE__*/_jsx(StatusTag, {
    "data-test-id": "publish-status",
    use: tagUse,
    paddingInline: "0",
    flexShrink: "0",
    children: getMessage()
  });
};
export default PublishStatus;